import { ValidationErrors } from "@angular/forms";
import { StudioFormConfig } from "../models/inputElementTypes.model"
import {
  FormlyFormOptions,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { get as _get, first as _first, includes as _includes } from 'lodash';
import { fieldArrayConfig, getFieldArrayprops } from "./helpers";

export const sourceCategories = [
  {
      "label": "Accounting",
      "value": "Accounting"
  },
  {
      "label": "Advertising",
      "value": "Advertising"
  },
  {
      "label": "Analytics",
      "value": "Analytics"
  },
  {
      "label": "Business",
      "value": "Business"
  },
  {
      "label": "CRM",
      "value": "CRM"
  },
  {
      "label": "Call Center",
      "value": "Call Center"
  },
  {
      "label": "Customer Support",
      "value": "Customer Support"
  },
  {
      "label": "Database",
      "value": "Database"
  },
  {
      "label": "File",
      "value": "File"
  },
  {
      "label": "Marketing",
      "value": "Marketing"
  },
  {
      "label": "Marketplaces",
      "value": "Marketplaces"
  },
  {
      "label": "OMS/WMS",
      "value": "OMS/WMS"
  },
  {
      "label": "Payments",
      "value": "Payments"
  },
  {
      "label": "Project Management",
      "value": "Project Management"
  },
  {
      "label": "Reviews",
      "value": "Reviews"
  },
  {
      "label": "Shipping",
      "value": "Shipping"
  },
  {
      "label": "Subscriptions",
      "value": "Subscriptions"
  },
  {
      "label": "Surveys",
      "value": "Surveys"
  },
  {
      "label": "eCommerce",
      "value": "eCommerce"
  },
  {
      "label": "Databases",
      "value": "Databases"
  }
]

export const sourceInfoFields = (isEditMode) => {
  let sourceFields: FormlyFieldConfig[] = [
    {
      key: "dataSourceName",
      type: "input",
      props: {
        label: "Source Name",
        placeholder: "Placeholder",
        description: "Description",
        required: true,
        appearance: "outline",
        existingNames: [],
        isEditable: true,
      },
      validators: {
        validation: getValidations(isEditMode, true, false),
      },
    },
    {
      key: "dataSourceType",
      type: "input",
      props: {
        label: "Datasource Type",
        placeholder: "Placeholder",
        description: "Description",
        required: true,
        appearance: "outline",
        existingNames: [],
        readonly: isEditMode,
        isEditable: false,
        specialCharacters: true,
      },
      validators: {
        validation: getValidations(isEditMode, false, true),
      },
    },
    {
      key: "sourceLogo",
      type: "file-upload",
      props: {
        label: "Source Logo",
        placeholder: "Placeholder",
        description: "Description",
        required: false,
        hidden: true,
      },
    },
    {
      key: "category",
      type: "select",
      props: {
        label: "Category",
        placeholder: "Placeholder",
        description: "Description",
        required: true,
        appearance: "outline",
        options: sourceCategories,
      },
    },
  ];
  return sourceFields;
};

const blockData = {
    "id": 1,
    "group": 1,
    "groupName": "Entity Processor",
    "groupValue": "ENTITY_PROCESSOR",
    "name": "Step block",
    "value": "STEP_BLOCK_NODE",
    "shape": "circle",
    "typenode": false,
    "isDraggable": true,
    "isDeletable": true,
    "class": "data-processor rectangle-block",
    "data": {
      "template": "Write your template"
    },
    "inputs": 1,
    "outputs": 1,
    "params": {},
    "inputElements": [
        {
          type: 'input',
          key: 'title',
          name: 'title',
          studioInputName: 'Title',
          studioInputType: 'input',
          studioInputId: '-1',
          className: 'source-info-field',
          defaultValue: 'Begin Configuration',
          props: {
            label: 'Step title',
            placeholder: 'Title',
            required: true,
            appearance: 'outline',        
          }
        },
        {
          type: 'textarea',
          key: 'helpText',
          name: 'helpText',
          studioInputName: 'Title',
          studioInputType: 'input',
          studioInputId: '-1',
          className: 'source-info-field',
          defaultValue: 'Step description goes here',
          props: {
            label: 'Help text',
            placeholder: 'Title',
            required: true,
            appearance: 'outline',
            rows: 3 
          }
        },
        {
          type: 'input',
          key: 'nextStepButtonLabel',
          name: 'nextStepButtonLabel',
          studioInputName: 'Title',
          studioInputType: 'input',
          studioInputId: '-1',
          className: 'source-info-field',
          defaultValue: 'Next',
          props: {
            label: 'Next step button label',
            placeholder: 'Title',
            required: true,
            appearance: 'outline',        
          }
        },
        {
          type: 'input',
          key: 'previousStepButtonLabel',
          name: 'previousStepButtonLabel',
          studioInputName: 'Title',
          studioInputType: 'input',
          studioInputId: '-1',
          className: 'source-info-field',
          defaultValue: 'Previous',
          props: {
            label: 'Previous step button label',
            placeholder: 'Title',
            required: true,
            appearance: 'outline',        
          }
        },
        {
          type: 'code-editor',
          key: 'variablePoolModifierScript',
          name: 'variablePoolModifierScript',
          studioInputName: 'Variable pool modifier script',
          studioInputType: 'CODE_EDITOR',
          className: 'source-info-field',
          defaultValue: '',
          studioInputId: '-1',
          props: {
            label: 'Variable pool modifier script',
            placeholder: 'Title',
            required: false,
          }
        },
      ]
  }

export const blocks = {
    "FIRST_STEP_NODE": {
        ...blockData, 
        "name": "First step block",
        "value": "FIRST_STEP_NODE",
        "isDeletable": false,
        "isDraggable": false,
        "inputs": 0
    },
    "NORMAL_STEP_NODE": {
        ...blockData,
        "name": "Normal step block",
        "value": "NORMAL_STEP_NODE",
    },
    "TABLE_SELECT_STEP_NODE": {
        ...blockData,
        "name": "Table select step block",
        "value": "TABLE_SELECT_STEP_NODE",
    },
    "COLUMN_SELECT_STEP_NODE": {
        ...blockData,
        "name": "Column select step block",
        "value": "COLUMN_SELECT_STEP_NODE",
    },
    "OAUTH_STEP_NODE": {
        ...blockData,
        "name": "Oauth step block",
        "value": "OAUTH_STEP_NODE",
    },
}


export const stepCreationButtons = [ 
  {
    'label': 'Dismiss',
    'type': 'no-change',
    'class': 'btn btn-outline btn-primary',
    'mat-style': 'mat-stroked-button',
    'color': 'primary'
  },
  {
    'label': 'Save',
    'type': 'submit',
    'class': 'btn btn-secondary ml-auto',
    'mat-style': 'mat-flat-button',
    'color': 'primary'
  }
]

export const topLevelFields: StudioFormConfig[] = [
  {
    type: 'input',
    key: 'title',
    studioInputName: 'Title',
    studioInputType: 'TEXT',
    studioInputId: '-1',
    className: 'source-info-field',
    defaultValue: 'Begin Configuration',
    props: {
      label: 'Step title',
      placeholder: 'Title',
      required: true,
      appearance: 'outline',        
    }
  },
  {
    type: 'textarea',
    key: 'helpText',
    studioInputName: 'Title',
    studioInputType: 'TEXT',
    studioInputId: '-1',
    className: 'source-info-field',
    defaultValue: 'Step description goes here',
    props: {
      label: 'Help text',
      placeholder: 'Title',
      required: true,
      appearance: 'outline',
      rows: 3 
    }
  },
  {
    type: 'textarea',
    key: 'setUpInstructionsUrl',
    studioInputName: 'Title',
    studioInputType: 'TEXT',
    studioInputId: '-1',
    className: 'source-info-field',
    defaultValue: '',
    props: {
      label: 'Setup Instructions Url',
      placeholder: 'Url',
      required: true,
      appearance: 'outline',
      rows: 2
    }
  },
  {
    type: 'input',
    key: 'nextStepButtonLabel',
    studioInputName: 'Title',
    studioInputType: 'TEXT',
    studioInputId: '-1',
    defaultValue: 'Next',
    className: 'source-info-field',
    props: {
      label: 'Next step button label',
      placeholder: 'Title',
      required: true,
      appearance: 'outline',        
    }
  },
  {
    type: 'input',
    key: 'previousStepButtonLabel',
    studioInputName: 'Title',
    studioInputType: 'TEXT',
    studioInputId: '-1',
    defaultValue: 'Previous',
    className: 'source-info-field',
    props: {
      label: 'Previous step button label',
      placeholder: 'Title',
      required: true,
      appearance: 'outline',        
    }
  },
  {
    type: 'code-editor',
    key: 'variablePoolModifierScript',
    name: 'Variable pool modifier script',
    studioInputName: 'Variable pool modifier script',
    studioInputType: 'CODE_EDITOR',
    className: 'source-info-field',
    studioInputId: '-1',
    defaultValue: '',
    props: {
      label: 'Variable pool modifier script',
      placeholder: 'Title',
      required: false,
    }
  },
  {
    type: "repeat",
    key: 'VARIABLE_POOL_VALIDATORS',
    name: "VARIABLE_POOL_VALIDATORS",
    className: 'source-info-field variablePoolValidator',
    props: {
      label: "Variable Pool Validators",
      ...getFieldArrayprops(),
    },
    fieldArray: {
      fieldGroup: [
        {
          key: "type",
          type: "select",
          className: "step-builder-field",
          defaultValue: null,
          props: {
            type: 'select',
            label: "Validator Type",
            appearance: "outline",
            options: [
              { value: 'API_CALL_VARIABLE_POOL_VALIDATOR', label: 'API_CALL_VARIABLE_POOL_VALIDATOR' },
            ]
          },
        },
        {
          key: "queryParams",
          type: "keyValue",
          className: "step-builder-field",
          props: {
            ...getFieldArrayprops(),
            label: "Query Params",
            paramsModificatonRequired: true,
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
          fieldArray: fieldArrayConfig()
        },
        {
          key: "headerParams",
          type: "keyValue",
          className: "step-builder-field",
          props: {
            ...getFieldArrayprops(),
            label: "Header Params",
            paramsModificatonRequired: true,
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
          fieldArray: fieldArrayConfig()
        },
        {
          key: "requestBodyType",
          type: "select",
          className: "step-builder-field",
          defaultValue: 'NONE',
          props: {
            type: 'select',
            label: "Request Body Type",
            appearance: "outline",
            options: [
              { value: 'NONE', label: 'NONE' },
              { value: 'FORM_DATA', label: 'FORM_DATA' },
              { value: 'X_WWW_FORM_URLENCODED', label: 'X_WWW_FORM_URLENCODED' },
              { value: 'RAW', label: 'RAW' },
              { value: 'BINARY', label: 'BINARY' },
              { value: 'GRAPHQL', label: 'GRAPHQL' },
            ]
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
        },
        {
          key: "requestBody",
          type: "json-editor",
          className: "step-builder-field json-editor-field",
          defaultValue: {},
          props: {
            label: 'Request Body',
            autosize: true,
            autosizeMinRows: 4,
            mode: "text",
            modes: ["text"],
            expandAll: false,
            readonly: false
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
        },
        {
          key: 'requestMethod',
          type: 'select',
          className: 'step-builder-field',
          defaultValue: 'GET',
          props: {
            type: 'select',
            label: 'Request Method',
            required: false,
            appearance: 'outline',
            options: [
              { value: 'GET', label: 'GET' },
              { value: 'POST', label: 'POST' },
              { value: 'PUT', label: 'PUT' },
              { value: 'PATCH', label: 'PATCH' },
              { value: 'DELETE', label: 'DELETE' }
            ]
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
        },
        {
          key: 'endpoint',
          type: 'input',
          className: 'step-builder-field',
          defaultValue: '',
          props: {
            type: 'textarea',
            label: 'Endpoint',
            appearance: 'outline'
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
        },
        {
          type: 'input',
          key: 'validatorScript',
          className: 'step-builder-field',
          defaultValue: '',
          props: {
            type: 'textarea',
            label: 'Validator Script',
            appearance: 'outline',
          },
          expressions: {
            hide: (field: FormlyFieldConfig) => {
              return _get(field, 'parent.model.type') !== "API_CALL_VARIABLE_POOL_VALIDATOR"
            }
          },
        },
      ]
    },
  },
]

export const stepCreationFields: FormlyFieldConfig[] = [
  {
    key: 'stepTitle',
    name: 'stepTitle',
    type: 'input',
    props: {
      label: 'Step title',
      placeholder: 'Step title',
      required: true
    }
  },
  // {
  //   key: 'helpText',
  //   name: 'helpText',
  //   type: 'textarea',
  //   props: {
  //     label: 'Step help text',
  //     placeholder: 'Step help text',
  //     required: true,
  //     rows: 3
  //   }
  // },
  // {
  //   key: 'nextStepButtonLabel',
  //   name: 'nextStepButtonLabel',
  //   type: 'input',
  //   props: {
  //     label: 'Step title',
  //     placeholder: 'Step title',
  //     required: true
  //   }
  // },
  // {
  //   key: 'previousStepButtonLabel',
  //   name: 'previousStepButtonLabel',
  //   type: 'input',
  //   props: {
  //     label: 'Step title',
  //     placeholder: 'Step title',
  //     required: true
  //   }
  // },
  {
    key: 'nodeType',
    name: 'nodeType',
    type: 'select',
    defaultValue: 'NORMAL_STEP_NODE',
    props: {
      label: 'Step type',
      placeholder: 'Step type',
      required: true,
      appearance: 'outline',
      options: [
        {
          label: 'Normal step',
          value: 'NORMAL_STEP_NODE'
        },
        {
          label: 'Table select step',
          value: 'TABLE_SELECT_STEP_NODE'
        },
        {
          label: 'Column select step',
          value: 'COLUMN_SELECT_STEP_NODE'
        },
        {
          label: 'Oauth step',
          value: 'OAUTH_STEP_NODE'
        }
      ]
    }
  }
]


export const variablePoolDialogButtons = [
  {
    'label': 'Dismiss',
    'type': 'no-change',
    'class': 'btn btn-outline',
    'mat-style': 'mat-stroked-button',
    'color': ''
  },
  {
    'label': 'Save',
    'type': 'save',
    'class': 'btn btn-secondary ml-auto',
    'mat-style': 'mat-flat-button',
    'color': ''
  }
]


export const stepEdgesFields = (connection, params) => {
  return [
    {
      key: 'toNodeId',
      defaultValue: connection.input_id,
    },
    {
      key: 'fromNodeId',
      defaultValue: connection.output_id,
    },
    {
      key: 'type',
      name: 'type',
      type: 'select',
      className: 'edge-info-field',
      defaultValue: _get(params, 'type', 'NONE_ACTIVATION_CONDITION'),
      props: {
        label: 'Edge type',
        placeholder: 'Edge type',
        required: true,
        appearance: 'outline',
        options: [
          {
            label: 'None',
            value: 'NONE_ACTIVATION_CONDITION'
          },
          {
            label: 'Simple equality',
            value: 'SIMPLE_EQUALITY_ACTIVATION_CONDITION'
          }
        ]
      }
    }, {
      key: 'lhsJsonPath',
      name: 'lhsJsonPath',
      type: 'textarea',
      className: 'edge-info-field',
      defaultValue: _get(params, 'lhsJsonPath', ''),
      props: {
        label: 'lhsJsonPath',
        placeholder: 'lhsJsonPath',
        required: false,
        appearance: 'outline',
      },
      expressions: {
        hide: (field: FormlyFieldConfig) => {
          return field.parent.model?.type === "NONE_ACTIVATION_CONDITION"
        }
      }
    },
    {
      key: 'equateTo',
      name: 'equateTo',
      type: 'input',
      className: 'edge-info-field',
      defaultValue: _get(params, 'equateTo', ''),
      props: {
        label: 'equateTo',
        placeholder: 'equateTo',
        required: false
      },
      expressions: {
        hide: (field: FormlyFieldConfig) => {
          return field.parent.model?.type === "NONE_ACTIVATION_CONDITION"
        }
      }
    }
  ]
}

export const getValidations = (isEditMode, isEditable, specialCharacters) => {
  let validations = [];
  if(!isEditMode || isEditable){
    validations.push('existingNamesValidator');
  }
  if(!isEditMode && specialCharacters){
    validations.push('specialCharactersValidator');
  }
  return validations;
}

export const existingNameValidation = (control: any): ValidationErrors => {
  return !_includes(_get(_first(control._fields), 'props.existingNames'), control.value) ? null : { 'existingNamesValidator': true };
}

export const existValidatorMessage = (error: any, field: FormlyFieldConfig) => {
  return `This ${_get(field, 'props.label')} already exists`;
}

export const specialCharactersValidation = (control: any): ValidationErrors => {
  let capsNumbersRegex = new RegExp("^[A-Z]{1}(?!.*__)[A-Z0-9_]{1,}[A-Z0-9]{1}$");
  return capsNumbersRegex.test(control.value) ? null : { 'specialCharactersValidator': true };
}

export const specialCharactersValidatorMessage = (error: any, field: FormlyFieldConfig) => {
  return `${_get(field, 'props.label')} can have only capital letters, numbers or an underscore( _ ) allowed. No
  spaces allowed. Cannot have two consecutive underscores. Starting character can only be alphabets. Minimum of 3 characters are required.`;
}